<template>
  <section>
    <div class="container">
      <div class="canvas" id="_canvas">
        <transition name="el-fade-in-linear">
          <div id="_canvas_menu" v-show="cMenuShow" class="menu">
            <div class="menu_label" @click="createTower">添加塔吊</div>
            <div class="menu_line"></div>
            <div class="menu_label" @click="backPosition($event,'top')">图纸居上</div>
            <div class="menu_label" @click="backPosition($event,'bottom')">图纸居下</div>
            <div class="menu_label" @click="backPosition($event,'center')">图纸居中</div>
            <div class="menu_label" @click="backPosition($event,'left')">图纸居左</div>
            <div class="menu_label" @click="backPosition($event,'right')">图纸居右</div>
            <div class="menu_line"></div>
            <div class="menu_label" @click="clearTower">清空塔吊</div>
          </div>
        </transition>
        <transition name="el-fade-in-linear">
          <div id="_tower_menu" v-show="tMenuShow" class="menu">
            <div class="menu_label" @click="showArm">显示塔臂</div>
            <div class="menu_label" @click="hidArm">显示十字</div>
            <div class="menu_line"></div>
            <div class="menu_label" @click="delTower">删除</div>
          </div>
        </transition>

      </div>
      <div class="tools">
        <div class="createBtn">
          <ProjectList @proSelected="proChange"></ProjectList>
        </div>
        <div class="createBtn">
          <el-button size="small" type="success" @click="create">添加塔吊</el-button>
          <el-button size="small" type="info" @click="clearTower">清除塔吊</el-button>
          <el-button size="small" type="warning" @click="completeLayout">完成布局</el-button>
        </div>
        <table class="dataArea">
          <tr>
            <td colspan="2" class="dataTitle">设备序列号</td>
          </tr>
          <tr> <td align="left" class="sn">{{sn}}</td></tr>
          <tr>
            <td colspan="2" class="dataTitle">位置</td>
          </tr>
          <tr> <td class="dataLabel">X 轴</td></tr>
          <tr>
           <td><el-slider v-model="tower.x" show-input input-size="mini" :min="0" :max="tower.maxX" @input="changeCoordinate($event,1)"></el-slider></td>
          </tr>
          <tr> <td class="dataLabel">Y 轴</td></tr>
          <tr>
            <td><el-slider v-model="tower.y" show-input input-size="mini" :min="0" :max="tower.maxY" @input="changeCoordinate($event,2)"></el-slider></td>
          </tr>
          <tr>
            <td class="dataTitle">半径</td>
          </tr>
          <tr>
            <td><el-slider v-model="tower.r" show-input input-size="mini" :max="tower.maxR"  @input="changeR"></el-slider></td>
          </tr>
          <tr>
            <td class="dataTitle">角度 <span style="color: red">(初始指向应在图纸正北方向)</span></td>
          </tr>
          <tr>
            <td ><el-slider v-model="tower.angle" show-input input-size="mini" @input="changeAngle($event)" :max="180" :min="-180"></el-slider></td>
          </tr>
          <tr>
            <td >
              <el-button size="small" class="angleBtn" @click="changeAngle(null,0)">0°</el-button>
              <el-button size="small" @click="changeAngle(null,90)">90°</el-button>
              <el-button size="small" @click="changeAngle(null,180)">180°</el-button>
              <el-button size="small" @click="changeAngle(null,-90)">270°</el-button>
            </td>
          </tr>
          <tr>
            <td  class="dataTitle">小车</td>
          </tr>
          <tr>
            <td ><el-slider v-model="tower.car" show-input input-size="mini" :max="tower.carMax" :min="0" @input="changeCar"></el-slider></td>
          </tr>
          <tr>
            <td  class="dataTitle">图纸</td>
          </tr>
          <tr> <td class="dataLabel">X 轴</td></tr>
          <tr>
            <td><el-slider v-model="dx" show-input input-size="mini" :max="100" :min="-100" @input="changeDesignerPic($event,1)"></el-slider></td>
          </tr>
          <tr> <td class="dataLabel">Y 轴</td></tr>
          <tr>
            <td><el-slider v-model="dy" show-input input-size="mini" :max="100" :min="-100" @input="changeDesignerPic($event,2)"></el-slider></td>
          </tr>
          <tr> <td class="dataLabel">宽</td></tr>
          <tr>
            <td><el-slider v-model="dw" show-input input-size="mini" :max="maxDw"  @input="changeDsize($event,1)"></el-slider></td>
          </tr>
          <tr> <td class="dataLabel">高</td></tr>
          <tr>
            <td><el-slider v-model="dh" show-input input-size="mini" :max="maxDh"  @input="changeDsize($event,2)"></el-slider></td>
          </tr>
          <tr>
            <td >
              <el-button size="small" class="angleBtn" @click="backPosition($event,'top')">居上</el-button>
              <el-button size="small" @click="backPosition($event,'center')">居中</el-button>
              <el-button size="small" @click="backPosition($event,'bottom')">居下</el-button>
              <el-button size="small" @click="backPosition($event,'left')">居左</el-button>
              <el-button size="small" @click="backPosition($event,'right')">居右</el-button>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <el-upload
                class="upload"
                :action="this.GLOBAL.baseServerPath+'/imgupload'"
                :headers="this.GLOBAL.fileHeader"
                name="file"
                list-type="picture-card"
                :limit="1"
                accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG,"
                :on-exceed="handleDesignExceed"
                :on-remove="removeDesignUpload"
                :on-success="successDesignUpload"
                :file-list="designList">
                <div class="pic_btn"><i class="el-icon-plus"></i></div>
              </el-upload>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <el-dialog title="" :visible.sync="formVisible" :close-on-click-modal="false" :modal="false" @close="dialogClose" width="30%" top="35vh">
        <el-form :model="formObj" :rules="fromRules" ref="formObj" label-width="120px" @submit.native.prevent>
          <el-form-item label="设备序列号" prop="sn">
              <el-input size="small" v-model="formObj.sn" placeholder="请输入设备序列号"></el-input>
          </el-form-item>
        </el-form>
        <div class="footer">
          <el-button type="success" @click.native="doSubmit">确定</el-button>
          <el-button @click.native="doCancel">取消</el-button>
        </div>
    </el-dialog>
  </section>
</template>

<script>
  import ProjectList from "../command/ProjectList";
  import {towerConfig,towerConfigByProId} from '../../api/api'
  export default {
    name: "TowerLayout",
    components: {ProjectList},
    data() {
      return {
        canvasW: 1170,//图纸宽度
        canvasH: 830,//图纸高度
        bgPosition:['50%','50%'],//图纸位置
        bgSize:[],
        bgUrl:null,
        dx:0,dy:0,dw:0,dh:0,maxDw:0,maxDh:0,dow:0,doh:0,
        X: 500,//塔吊x轴初始值
        Y: 300,//塔吊y轴初始值
        R: 55,//塔吊半径初始值
        Angle: 0,//塔吊旋转角度初始值
        carWay: 0,//小车位置初始值
        towerArmAngleOffset: 0,//塔臂偏移角度
        tower:{x:null,y:null,r:null,angle:null,car:null,maxX:null,maxY:null,maxR:this.R,
              carMax:this.R},
        towerList: [],
        designList:[],
        towerNum: 1,//塔吊计数
        cMenuShow: false,
        tMenuShow: false,
        zIndex:90,
        currentTower:null,//当前选中塔吊
        projectId:null,
        formVisible:false,
        formObj: {sn:null},
        fromRules: {
          sn: [
            {required: true, message: '请输入设备序列号', trigger: 'blur'}
          ],
        },
        sn:null,
      }
    },
    methods: {
      create:function(){
        this.formVisible = true;

      },
      doCancel:function(){
        this.formVisible = false;
      },
      doSubmit:function(){
        this.$refs.formObj.validate((valid) => {
          if (valid) {
            this.createTower(null,this.formObj.sn);
          }
        });
      },
      dialogClose:function(){
        this.$refs['formObj'].resetFields();
      },
      createTower: function (e,sn) {
        let _this = this;
        let canvas = document.getElementById("_canvas");
        //新建一个塔吊
        let tower = document.createElement('div');
        tower.className = 'tower';
        tower.style.position = 'absolute';
        tower.style.border = '1.5px dashed #00A800';
        tower.style.height = this.R * 2 + 'px';
        tower.style.width = this.R * 2 + 'px';
        tower.style.borderRadius = this.R * 2 + 'px';
        tower.style.left = (this.X) + 'px';
        tower.style.top = (this.Y) + 'px';
        tower.style.textAlign = 'center';
        tower.style.display = 'flex';
        tower.style.zIndex = this.zIndex;

        tower.onmousedown = function (e) {
          _this.towerDown(e, tower)
        };

        tower.onmouseover = function (e) {
          _this.sizePoint(e, tower)
        };

        tower.setAttribute('group', 'tower');
        tower.setAttribute('named', 'towerBorder');
        tower.setAttribute('id', this.towerNum);//设置塔吊属性
        tower.setAttribute('X', this.X);
        tower.setAttribute('Y', this.Y);
        tower.setAttribute('R', this.R);
        tower.setAttribute('Angle', this.Angle);
        tower.setAttribute('carWay', this.carWay);
        tower.setAttribute('sn',sn);

        tower.setAttribute('labelArea', 'labelArea_' + this.towerNum);
        tower.setAttribute('towerArmContainer', 'towerArmContainer_' + this.towerNum)
        tower.setAttribute('area', 'area_' + this.towerNum);
        tower.setAttribute('active','0');
        //塔吊区域=======================================
        let area = document.createElement('div');//塔吊区域容器
        area.style.position = 'relative';
        area.style.height = '100%';
        area.style.width = '100%';
        area.style.borderRadius = '100%';
        area.style.alignSelf = 'center';
        area.style.margin = 'auto';
        area.style.display = 'flex'
        area.style.cursor = 'default';

        area.onmousedown = function (e) {
          _this.areaMove(e, area, tower)
        };

        area.setAttribute('group', 'tower');
        area.setAttribute('named', 'area');
        area.setAttribute('id', 'area_' + this.towerNum);

        let alphaArea = document.createElement('div');//塔吊区域遮罩
        alphaArea.style.position = 'absolute';
        alphaArea.style.height = '100%';
        alphaArea.style.width = '100%';
        alphaArea.style.borderRadius = '100%';
        alphaArea.style.background = '#e6fffa';
        alphaArea.style.opacity = '0.3';
        alphaArea.style.left = '0px';
        alphaArea.style.top = '0px';

        alphaArea.setAttribute('group', 'tower');
        alphaArea.setAttribute('named', 'alphaArea');
        alphaArea.setAttribute('id', 'alphaArea_'+this.towerNum);//设置塔吊属性

        let towerArea = document.createElement('div');//塔吊画布
        towerArea.style.position = 'absolute';
        towerArea.style.height = '100%';
        towerArea.style.width = '100%';
        towerArea.style.borderRadius = '100%';
        towerArea.style.textAlign = 'center';
        towerArea.style.left = '0px';
        towerArea.style.top = '0px';
        towerArea.style.display = 'flex'

        towerArea.setAttribute('group', 'tower');
        towerArea.setAttribute('named', 'towerArea');

        this.createArm(towerArea,this.Angle,this.towerNum,this.carWay);//塔臂

        area.appendChild(alphaArea);
        area.appendChild(towerArea);
        this.createCenterPoint(area, true,this.towerNum)//中心点 驾驶室
        tower.appendChild(area);
        canvas.appendChild(tower);

        this.activeTower(e,tower);

        this.X = this.X + 35;
        this.Y = this.Y + 35;
        this.towerNum++;
        this.formVisible = false;
      },
      //创建塔臂
      createArm: function (container,angle,towerNum,carWay) {
        //塔吊臂=======================================
        let towerArmContainer = document.createElement('div');//塔臂容器
        towerArmContainer.style.position = 'relative';
        towerArmContainer.style.height = '16px';
        towerArmContainer.style.width = '100%';
        towerArmContainer.style.alignSelf = 'center';
        towerArmContainer.style.textAlign = 'left';
        towerArmContainer.style.transform = 'rotate(' + (this.towerArmAngleOffset + angle) + 'deg)';

        //towerArmContainer.style.display = 'none';


        towerArmContainer.setAttribute('group', 'tower');
        towerArmContainer.setAttribute('named', 'towerArmC');
        towerArmContainer.setAttribute('id', 'towerArmContainer_' + towerNum);
        towerArmContainer.onmousedown = function(e){
          if(e.button==2){
            towerArmContainer.style.border = '1px dashed #e8e8e8';
            towerArmContainer.onmouseup = function(){
              towerArmContainer.style.border = 'none';
            }
          }
        }
        let towerArm = document.createElement('div');//塔臂
        towerArm.style.position = 'absolute';
        towerArm.style.height = '100%';
        towerArm.style.width = '50%';
        towerArm.style.left = '0px';
        towerArm.style.top = '0px';
        towerArm.style.background = 'url("../../../static/tower/tower_arm.png")';

        towerArm.setAttribute('group', 'towerArm');
        towerArm.setAttribute('named', 'towerArm');

        let towerWeightContainer = document.createElement('div');//塔吊配重容器
        towerWeightContainer.style.position = 'absolute';
        towerWeightContainer.style.height = '100%';
        towerWeightContainer.style.width = '53px';
        towerWeightContainer.style.maxWidth = '90px'
        towerWeightContainer.style.minWidth = '37px'
        towerWeightContainer.style.left = '50%';
        towerWeightContainer.style.top = '0px';
        towerWeightContainer.style.background = 'url("../../../static/tower/tower_arm.png")';

        towerWeightContainer.setAttribute('group', 'tower');
        towerWeightContainer.setAttribute('named', 'towerWeightC');

        let towerWeight = document.createElement('div');//塔吊配重
        towerWeight.style.position = 'absolute';
        towerWeight.style.height = '20px';
        towerWeight.style.width = '25px';
        towerWeight.style.right = '0px';
        towerWeight.style.top = '-2px';
        towerWeight.style.background = 'url("../../../static/tower/tower_weight.png")';
        towerWeight.setAttribute('group', 'tower');
        towerWeight.setAttribute('named', 'towerWeight');

        let towerCar = document.createElement('div');//塔臂小车
        towerCar.style.position = 'absolute';
        towerCar.style.height = '18px';
        towerCar.style.width = '18px';
        towerCar.style.background = 'url("../../../static/tower/tower_car.png")';
        towerCar.style.right = carWay + 10 + 'px';
        towerCar.style.top = '-1px';
        towerCar.setAttribute('group', 'towerCar');
        towerCar.setAttribute('named', 'towerCar');
        towerCar.setAttribute('id', 'towerCar_'+towerNum);
        //=============================================
        towerArm.appendChild(towerCar);
        towerWeightContainer.appendChild(towerWeight);
        towerArmContainer.appendChild(towerWeightContainer);
        towerArmContainer.appendChild(towerArm);
        container.appendChild(towerArmContainer);
      },
      showArm: function (e) {
        let armC = e.target.parentElement.parentElement.getAttribute('towerArmContainer');
        let armCElement = document.getElementById(armC);
        armCElement.style.display = 'block';

        let labelArea = e.target.parentElement.parentElement.getAttribute('labelArea');
        let labelAreaElement = document.getElementById(labelArea);
        labelAreaElement.style.background = 'url("../../../static/tower/tower_driver.png")';
        let num = labelArea.substring(labelArea.indexOf('_') + 1);
        labelAreaElement.innerHTML = num;
      },
      hidArm: function (e) {
        let armC = e.target.parentElement.parentElement.getAttribute('towerArmContainer');
        let armCElement = document.getElementById(armC);
        armCElement.style.display = 'none';

        let labelArea = e.target.parentElement.parentElement.getAttribute('labelArea');
        let labelAreaElement = document.getElementById(labelArea);
        labelAreaElement.style.background = 'url("../../../static/tower/point.png")';
        labelAreaElement.innerHTML = '';
      },
      //创建中心点
      createCenterPoint: function (container, flag,towerNum) {
        let labelArea = document.createElement('div');//塔吊文本区域
        labelArea.style.position = 'relative';
        labelArea.style.height = '20px';
        labelArea.style.width = '20px';
        labelArea.style.lineHeight = '20px';
        labelArea.style.alignSelf = 'center';
        labelArea.style.margin = 'auto';
        if (flag) {
          labelArea.style.background = 'url("../../../static/tower/tower_driver.png")';//
          labelArea.innerHTML = towerNum;
        } else {
          labelArea.style.background = 'url("../../../static/tower/point.png")';//
        }
        labelArea.style.color = '#0B3564';
        labelArea.style.fontWeight = 'bold';

        labelArea.setAttribute('group', 'tower');
        labelArea.setAttribute('named', 'labelArea');
        labelArea.setAttribute('id', 'labelArea_' + towerNum);
        container.appendChild(labelArea);
      },
      //塔吊移动/塔臂移动/小车移动
      areaMove: function (e, obj, parent) {
        //塔吊移动
        if (e.button == 0 && e.target.getAttribute('group') == 'tower') {
          obj.style.cursor = 'move';
          obj.onmouseup = function () {
            obj.style.cursor = 'default';
            obj.onmouseup = null;
          };
          document.onmouseup = function () {
            obj.style.cursor = 'default';
            document.onmousemove = null;
            document.onmouseup = null;
          };

          const disX = e.clientX;
          const disY = e.clientY;
          const left = parseInt(parent.style.left);
          const top = parseInt(parent.style.top);

          let canvas = document.getElementById('_canvas');
          let canvas_w = parseInt(canvas.style.width);
          let canvas_h = parseInt(canvas.style.height);
          let _this = this;
          document.onmousemove = function (e) {
            let changeLeft = (left + (e.clientX - disX));
            let changeTop = (top + (e.clientY - disY));
            let changeRight = changeLeft + parseInt(parent.style.height) + 1;
            let changeBottom = changeTop + parseInt(parent.style.height) + 1;

            if (changeLeft >= 0 && changeTop >= 0 && changeRight < canvas_w && changeBottom < canvas_h) {
              parent.setAttribute('X',changeLeft);
              parent.setAttribute('Y',changeTop);
              _this.tower.x = changeLeft;
              _this.tower.y = changeTop;
            }
          }
        }
        //移动塔臂
        if (e.button == 0 && e.target.getAttribute('group') == 'towerArm') {
          let towerArm = e.target;
          let towerContainer =towerArm.parentElement;
          let area = obj;
          towerArm.style.cursor = 'move';
          towerArm.onmouseup = function () {
            towerArm.style.cursor = 'default';
            towerArm.onmouseup = null;
          };
          let R = parseInt(area.parentElement.style.width)/2;//当前圆半径

          let _this = this;
          const X =0;//e.clientX
          const Y =0;//e.clientY
          area.onmouseup = function () {
            towerArm.style.cursor = 'default';
            area.onmousemove = null;
            area.onmouseup = null;
          };
          document.onmouseup  = function(){ towerArm.style.cursor = 'default';area.onmousemove = null;area.onmouseup = null;document.onmouseup=null;}
          area.onmousemove = function (e) {
            if(e.target.getAttribute('named')=='towerArea'){
              const mX = e.offsetX-R;
              const mY = R-e.offsetY-8;
              let angle = Math.atan2(mY-Y,X-mX)*(180/Math.PI);
              parent.setAttribute('Angle',angle);
              _this.tower.angle = angle;

            }
          }
        }
        //移动小车
        if (e.button == 0 && e.target.getAttribute('group') == 'towerCar') {
          let _this = this;
          let towerCar = e.target;
          let towerArm =towerCar.parentElement;
          towerCar.style.cursor = 'move';
          towerCar.onmouseup = function () {
            towerCar.style.cursor = 'default';
            towerCar.onmouseup = null;
          };

          towerArm.onmouseup = function(){ towerCar.style.cursor = 'default';towerArm.onmousemove = null;towerArm.onmouseup = null;}
          document.onmouseup  = function(){ towerCar.style.cursor = 'default';towerArm.onmousemove = null;towerArm.onmouseup = null;document.onmouseup=null;}
          towerArm.onmousemove = function (e) {
            if(e.target.getAttribute('named')=='towerArm'){
              let R = parseInt(parent.style.width)/2;
              let point = ( R- e.offsetX);
              if(point<R-18){
                _this.tower.car = point;
              }
              parent.setAttribute('carWay',point);
            }
          }

        }
      },
      //改变塔吊大小指针变化
      sizePoint: function (e, obj) {
        let currentElement = obj;
        this.cMenuShow = false;
        if (e.target.getAttribute('named') == 'towerBorder') {
          let R = parseInt(currentElement.style.height) / 2;

          let offset = 25;
          let offsetY = e.offsetY;
          let offsetX = e.offsetX;

          if (offsetY < R - offset && offsetX > R + offset) {
            currentElement.style.cursor = 'ne-resize'//东北;
          } else if (offsetY > R + offset && offsetX > R + offset) {
            currentElement.style.cursor = 'se-resize';//东南
          } else if (offsetY > R + offset && offsetX < R - offset) {
            currentElement.style.cursor = 'sw-resize';//西南
          } else if (offsetY < R - offset && offsetX < R - offset) {
            currentElement.style.cursor = 'nw-resize';//西北
          } else if (offsetY >= R - offset && offsetY <= R + offset && offsetX > R) {
            currentElement.style.cursor = 'e-resize';//东
          } else if (offsetY >= R - offset && offsetY <= R + offset && offsetX < R) {
            currentElement.style.cursor = 'w-resize';//西
          } else if (offsetY < R && offsetX >= R - offset && offsetX <= R + offset) {
            currentElement.style.cursor = 'n-resize';//北
          } else if (offsetY > R && offsetX >= R - offset && offsetX <= R + offset) {
            currentElement.style.cursor = 's-resize';//南
          } else {
            currentElement.style.cursor = 'default';
          }
        }
        if (e.target.getAttribute('named') == 'towerArea') {
          this.tMenuShow = false;
        }

      },
      //塔吊点击
      towerDown: function (e, obj) {
        let currentElement = obj;
        //选中塔吊
        this.activeTower(e, currentElement);
        if (e.target.getAttribute('named') == 'towerBorder' && e.button == 0) {
          let direction = currentElement.style.cursor;

          const disX = e.clientX;
          const disY = e.clientY;

          const height = parseInt(currentElement.style.height);
          const left = parseInt(currentElement.style.left);
          const top = parseInt(currentElement.style.top);

          let canvas = document.getElementById('_canvas');
          let canvas_w = parseInt(canvas.style.width);
          let canvas_h = parseInt(canvas.style.height);
          let _this = this;
          document.onmousemove = function (e) {
            let offset = 0;

            if (direction == 'se-resize' || direction == 'sw-resize' || direction == 's-resize') {
              offset = e.clientY - disY;
            } else if (direction == 'ne-resize' || direction == 'nw-resize' || direction == 'n-resize') {
              offset = -(e.clientY - disY);
            } else if (direction == 'se-resize' || direction == 'sw-resize' || direction == 's-resize') {
              offset = e.clientY - disY;
            } else if (direction == 'w-resize') {
              offset = -(e.clientX - disX);
            } else if (direction == 'e-resize') {
              offset = e.clientX - disX;
            }

            let changeHeight = (height + offset);
            let changeLeft = (left - offset / 2);
            let changeTop = (top - offset / 2);
            let changeRight = changeLeft + parseInt(changeHeight) + 1;
            let changeBottom = changeTop + parseInt(changeHeight) + 1;

            if (changeHeight > _this.R * 2 && changeLeft >= 0 && changeTop >= 0 && changeRight < canvas_w && changeBottom < canvas_h) {
              //更新半径
              _this.tower.r = changeHeight/2;
            }
          };
          document.onmouseup = function (e) {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        }

        if (e.button == 2 && (e.target.getAttribute('named') == 'towerArea')) {
          this.tMenuShow = true;
          let offsetX = e.offsetX - 2;
          let offsetY = e.offsetY - 2;

          let menu = document.getElementById('_tower_menu');

          let R = parseInt(currentElement.style.width);

          let top = parseInt(currentElement.style.top);

          if(offsetY+152>R && top +offsetY>152) {
            menu.style.top = (offsetY-140) + 'px';
          }else {
            menu.style.top = offsetY + 'px';
          }
          if(offsetX+88>R){
            menu.style.left = (offsetX-88) + 'px';
          }else{
            menu.style.left = offsetX + 'px';
          }
          currentElement.appendChild(menu);
          let _this = this;
          let canvas = document.getElementById('_canvas');
          canvas.onmouseover = function (e) {
            if (e.target.className == 'canvas') {
              _this.tMenuShow = false;
              canvas.onmouseover = null;
            }
          }
        }
      },
      //选中某一塔吊
      activeTower: function (e, tower) {
        if(tower.getAttribute('active')=='0'){
          this.currentTower = tower;
          tower.style.borderColor = '#00ff00';
          tower.style.zIndex = (parseInt(tower.style.zIndex)+1);
          tower.setAttribute('active','1');
          let id = tower.getAttribute('id')
          let alphaArea = document.getElementById('alphaArea_'+id);
          alphaArea.style.background = '#c1ffae';
          //选中后
          //塔吊坐标=====================================
          this.tower.x = parseInt(tower.getAttribute('X'));
          this.tower.y = parseInt(tower.getAttribute('Y'));
          this.tower.maxX = this.canvasW - this.R*2-2;
          this.tower.maxY = this.canvasH - this.R*2-2;
          this.tower.maxR = this.canvasH/2;
          this.tower.r = parseInt(tower.getAttribute('R'));
          this.tower.angle =  parseInt(tower.getAttribute('Angle'));
          this.tower.car =  parseInt(tower.getAttribute('carWay'));
          this.tower.carMax = this.tower.r-18-10;
          this.sn = tower.getAttribute('sn');
        }
        let towers = document.getElementsByClassName('tower');
        for (let i = 0; i < towers.length; i++) {
          let towerElement = towers[i];
          if (towerElement.getAttribute('id') != tower.getAttribute('id')&&towerElement.getAttribute('active')=='1') {
            towerElement.style.borderColor = '#00A800';

            let id = towerElement.getAttribute('id')
            let alphaArea = document.getElementById('alphaArea_'+id);
            alphaArea.style.background = '#e6fffa';

            towerElement.style.zIndex =  (parseInt(towerElement.style.zIndex)-1);
            towerElement.setAttribute('active','0');
          }
        }
      },
      //删除塔吊
      delTower: function (e) {
        let canvas = document.getElementById("_canvas");
        let menu = document.getElementById('_tower_menu');
        canvas.removeChild(e.target.parentElement.parentElement)
        if (menu != null) {
          canvas.appendChild(menu);
        }
        this.tMenuShow = false;
        this.X = this.X - 35;
        this.Y = this.Y - 35;
        this.towerNum--;
      },
      //清空画布
      clearTower: function () {
        let canvas = document.getElementById("_canvas");
        let menu = document.getElementById('_tower_menu');
        if (menu != null) {
          canvas.appendChild(menu);
        }
        let towers = document.getElementsByClassName('tower');

        for (let i = 0; i < towers.length; i++) {
          this.towerList.push(towers[i]);
        }
        for (let i = 0; i < this.towerList.length; i++) {
          canvas.removeChild(this.towerList[i]);
        }
        this.towerList = [];
        this.X = 500;
        this.Y = 300;
        this.R = 55;
        this.Angle = 0;
        this.carWay = 0;
        this.towerNum = 1;
        this.tMenuShow = false;
        this.zIndex=90;
        this.dx=0;this.dy=0;this.dw=0;this.dh=0;
        this.tower.x=0;this.tower.y=0;this.tower.r=0;this.tower.angle=0;this.tower.car=0;
        this.sn = ''
      },
      backPosition:function(e,position){
        let canvas = document.getElementById('_canvas');
        this.bgPosition = ['0px','0px'];
        switch (position) {
          case 'top':
            this.dx = 50;
            if(this.dw>this.canvasW) {
              this.dx = -50
            }
            this.dy = 0;
            break;
          case 'bottom':
            this.dx = 50;
            if(this.dw>this.canvasW) {
              this.dx = -50;
            }
            this.dy = 100;
            if(this.dh>this.canvasH){
              this.dy = -100;
            }
            break;
          case 'center':
            this.dx = 50;
            if(this.dw>this.canvasW) {
              this.dx = -50;
            }
            this.dy = 50;
            if(this.dh>this.canvasH){
              this.dy = -50;
            }
            break;
          case 'left':
            this.dx = 0;
            this.dy = 50;
            if(this.dh>this.canvasH){
              this.dy = -50;
            }
            break;
          case 'right':
            this.dx = 100;
            if(this.dw>this.canvasW){
              this.dx = -100;
            }
            this.dy = 50;
            if(this.dh>this.canvasH){
              this.dy = -50;
            }
            break;
        }

      },
      //上传设计图成功
      successDesignUpload:function(response){
          let canvas = document.getElementById('_canvas');
          this.loadImg(response.data,canvas)
      },
      loadImg:function(url,canvas,position,size){
        canvas.style.backgroundImage = 'url('+this.GLOBAL.basePhotoPath+url+')';
        this.bgUrl = url;
        let img = new Image();
        let _this = this;
        let x = 50,y=50;
        if(position!=null){
          x = position[0];
          y = position[1];
        }

        img.onload = function(){
          _this.dw = img.width;
          _this.dh = img.height;
          _this.dow = img.width;
          _this.doh = img.height;
          if(size!=null){
            _this.dw = size[0];
            _this.dh = size[1];
            _this.dow = size[0];
            _this.doh = size[1];
          }
          _this.dx = x;
          _this.dy = y;
          if(_this.dw >_this.canvasW){
            _this.dx = -x;
            _this.maxDw = _this.dw;
          }else{
            _this.maxDw = _this.canvasW;
          }
          if(_this.dh > _this.canvasH){
            _this.dy = -y;
            _this.maxDh = _this.dh;
          }
          else{
            _this.maxDh = _this.canvasH;
          }
        };
        img.src = this.GLOBAL.basePhotoPath+url;
      },
      removeDesignUpload:function(){
        this.bgUrl =null;
        let canvas = document.getElementById('_canvas');
        canvas.style.backgroundImage = null
      },
      handleDesignExceed: function (files,fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      //工具栏事件=========================
      //改变坐标 1 x 轴 2 y 轴
      changeCoordinate:function(data,p){
          if(this.currentTower!=null){
            let canvas = document.getElementById('_canvas');
            let canvas_w = parseInt(canvas.style.width);
            let canvas_h = parseInt(canvas.style.height);
            if(p==1){
              let changeRight = data + parseInt(this.currentTower.style.height) + 1;
              if (data >= 0 && changeRight < canvas_w ) {
                this.currentTower.style.left = data + 'px';
                this.currentTower.setAttribute('X', data);
              }
            }
            else if(p==2){
              let changeBottom = data + parseInt(this.currentTower.style.height) + 1;
              if (data >= 0 && changeBottom < canvas_h) {
                this.currentTower.style.top = data + 'px';
                this.currentTower.setAttribute('Y', data);
              }
            }

          }
      },
      //改变半径
      changeR:function(data){
        if(this.currentTower!=null){
          let left = this.currentTower.getAttribute('X');
          let top = this.currentTower.getAttribute('Y');
          let R = this.currentTower.getAttribute('R');

          let offset = data-R;

          let changeHeight = data*2;
          let changeLeft = (left - offset);
          let changeTop = (top - offset);
          let changeRight = changeLeft + changeHeight + 1;
          let changeBottom = changeTop + changeHeight + 1;

          if (changeHeight > this.R * 2 && changeLeft >= 0 && changeTop >= 0 && changeRight < this.canvasW && changeBottom < this.canvasH) {
            this.currentTower.style.height = changeHeight + 'px';
            this.currentTower.style.width = changeHeight + 'px';
            this.currentTower.style.borderRadius = changeHeight + 'px';

            this.tower.y = changeTop;
            this.tower.x = changeLeft;
            this.tower.maxX = this.canvasW - changeHeight - 2;
            this.tower.maxY = this.canvasH - changeHeight - 2;
            this.tower.carMax = data-18-10;
            this.currentTower.setAttribute('R', data);
          }
        }
      },
      //改变角度
      changeAngle:function(data,p){
        if(this.currentTower!=null){
          let id = this.currentTower.getAttribute('id');
          let towerContainer = document.getElementById('towerArmContainer_'+id);
          if(p!=null){
            this.tower.angle = p;
          }else{
            towerContainer.style.transform = 'rotate(' + data + 'deg)';
            this.currentTower.setAttribute('Angle',data);
          }
        }
      },
      //改变小车位置
      changeCar:function(data){
        if(this.currentTower!=null) {
          let id = this.currentTower.getAttribute('id');
          let towerCar = document.getElementById('towerCar_' + id);
          towerCar.style.right =(data+10)+'px';
          this.currentTower.setAttribute('carWay',data+10);
        }
      },
      //改变背景图纸位置
      changeDesignerPic:function(data,p){
        let canvas = document.getElementById('_canvas');
        let x = 0,y = 0;
        if(p==1) {
          x = data;
          if(this.dw>this.canvasW){
            x = -data;
          }
          y = this.dy;
          if(this.dh>this.canvasH){
            y = -this.dy;
          }
        }else if(p==2){
          x = this.dx;
          if(this.dw>this.canvasW){
            x = -this.dx;
          }
          y = data;
          if(this.dh>this.canvasH){
            y = -data;
          }
        }
        canvas.style.backgroundPosition = x+'% '+ y+'%';
        this.bgPosition=[];
        this.bgPosition.push(x);
        this.bgPosition.push(y);
      },
      //改变背景图纸大小
      changeDsize:function(data,p){
        let canvas = document.getElementById('_canvas');
        let width,height;
        if(p==1 && this.dow>0){
          width = (data);
          let per = width/this.dow;
          height = this.doh*per;
          this.dh = height;
        }else if(p==2 && this.dow>0){
          height = (data);
          let per = height/this.doh;
          width = this.dow*per;
          this.dw = width;
        }
        canvas.style.backgroundSize=width+'px '+ height+'px';
        this.bgSize = [];
        this.bgSize.push(width);
        this.bgSize.push(height);
      },
      completeLayout: function () {
        //塔吊数据
        let towers = document.getElementsByClassName('tower');
        let towerList = [];
        if(towers.length==0){
          this.$message({
            message: "请添加塔吊",
            type: 'error'
          });
        }else{
          for (let i = 0; i < towers.length; i++) {
            let tower = towers[i];
            let towerData = {
              x:tower.getAttribute('X'),
              y:tower.getAttribute('Y'),
              r:tower.getAttribute('R'),
              angle:tower.getAttribute('Angle'),
              car:tower.getAttribute('carWay'),
              id:tower.getAttribute('id'),
              sn:tower.getAttribute('sn')
            }
            towerList.push(towerData);
          }

          let param = {id:this.projectId,towerList:JSON.stringify(towerList),towerSize:JSON.stringify(this.bgSize),towerPosition:JSON.stringify(this.bgPosition),proDesign:this.bgUrl}

          towerConfig(param, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.$message({
                message: "布局完成",
                type: 'success'
              });
            }
          });
        }


      },
      proChange:function(proId){
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.tower, this.GLOBAL.option.select, this);
        if (res) {
          this.clearTower();
          this.projectId = proId;
          let params = {proId: this.projectId};//请求参数
          towerConfigByProId(params, this.GLOBAL.header).then(result => {
            if (result.success) {
              let canvas = document.getElementById('_canvas');

              if (result.data.proDesign != null && result.data.proDesign != '' && result.data.towerPosition != null && result.data.towerPosition != ''
                && result.data.towerSize != null && result.data.towerSize != '') {
                let position = JSON.parse(result.data.towerPosition);
                let size = JSON.parse(result.data.towerSize);

                this.loadImg(result.data.proDesign, canvas, position, size);
              } else {
                canvas.style.background = '';
                canvas.style.backgroundPosition = '50%,50%'
              }
              //初始化塔吊
              if (result.data.towerList != null && result.data.towerList != '') {

                let towerList = JSON.parse(result.data.towerList);

                for (let i = 0; i < towerList.length; i++) {
                  let tower = towerList[i];
                  let x = tower.x;
                  let y = tower.y;
                  let r = tower.r;
                  let angle = tower.angle;
                  let car = tower.car;
                  let id = tower.id;
                  let sn = tower.sn;
                  this.initTower(id, x, y, r, angle, car, sn);
                }
                this.towerNum = towerList.length + 1;
              }


            }
          });
        }
      },
      initTower: function (id,x,y,r,angle,car,sn) {
        let _this = this;
        let canvas = document.getElementById("_canvas");
        //新建一个塔吊
        let tower = document.createElement('div');
        tower.className = 'tower';
        tower.style.position = 'absolute';
        tower.style.border = '1.5px dashed #00A800';
        tower.style.height = r * 2 + 'px';
        tower.style.width = r * 2 + 'px';
        tower.style.borderRadius = r * 2 + 'px';
        tower.style.left = (x) + 'px';
        tower.style.top = (y) + 'px';
        tower.style.textAlign = 'center';
        tower.style.display = 'flex';
        tower.style.zIndex = this.zIndex;

        tower.onmousedown = function (e) {
          _this.towerDown(e, tower)
        };

        tower.onmouseover = function (e) {
          _this.sizePoint(e, tower)
        };

        tower.setAttribute('group', 'tower');
        tower.setAttribute('named', 'towerBorder');
        tower.setAttribute('id', id);//设置塔吊属性
        tower.setAttribute('X', x);
        tower.setAttribute('Y', y);
        tower.setAttribute('R', r);
        tower.setAttribute('Angle', angle);
        tower.setAttribute('carWay', car);
        tower.setAttribute('sn', sn);
        tower.setAttribute('labelArea', 'labelArea_' + id);
        tower.setAttribute('towerArmContainer', 'towerArmContainer_' + id)
        tower.setAttribute('area', 'area_' + id);
        tower.setAttribute('active','0');
        //塔吊区域=======================================
        let area = document.createElement('div');//塔吊区域容器
        area.style.position = 'relative';
        area.style.height = '100%';
        area.style.width = '100%';
        area.style.borderRadius = '100%';
        area.style.alignSelf = 'center';
        area.style.margin = 'auto';
        area.style.display = 'flex'
        area.style.cursor = 'default';

        area.onmousedown = function (e) {
          _this.areaMove(e, area, tower)
        };

        area.setAttribute('group', 'tower');
        area.setAttribute('named', 'area');
        area.setAttribute('id', 'area_' + id);

        let alphaArea = document.createElement('div');//塔吊区域遮罩
        alphaArea.style.position = 'absolute';
        alphaArea.style.height = '100%';
        alphaArea.style.width = '100%';
        alphaArea.style.borderRadius = '100%';
        alphaArea.style.background = '#e6fffa';
        alphaArea.style.opacity = '0.3';
        alphaArea.style.left = '0px';
        alphaArea.style.top = '0px';

        alphaArea.setAttribute('group', 'tower');
        alphaArea.setAttribute('named', 'alphaArea');
        alphaArea.setAttribute('id', 'alphaArea_'+id);//设置塔吊属性

        let towerArea = document.createElement('div');//塔吊画布
        towerArea.style.position = 'absolute';
        towerArea.style.height = '100%';
        towerArea.style.width = '100%';
        towerArea.style.borderRadius = '100%';
        towerArea.style.textAlign = 'center';
        towerArea.style.left = '0px';
        towerArea.style.top = '0px';
        towerArea.style.display = 'flex'

        towerArea.setAttribute('group', 'tower');
        towerArea.setAttribute('named', 'towerArea');

        this.createArm(towerArea,angle,id,car);//塔臂

        area.appendChild(alphaArea);
        area.appendChild(towerArea);
        this.createCenterPoint(area, true,id)//中心点 驾驶室
        tower.appendChild(area);
        canvas.appendChild(tower);

        this.activeTower(null,tower);
      },
    },
    mounted() {

      let _this = this;
      let canvas = document.getElementById('_canvas');
      canvas.style.width = this.canvasW + 'px';
      canvas.style.height = this.canvasH + 'px';

      canvas.onmousedown = function (e) {

        if (e.button == 2 && e.target.className == 'canvas') {
          _this.cMenuShow = true;
          let offsetX = e.offsetX - 2;
          let offsetY = e.offsetY - 2;
          let menu = document.getElementById('_canvas_menu');

          if(offsetY+335>_this.canvasH){
            menu.style.top = (offsetY-328) + 'px';
          }else{
            menu.style.top = offsetY + 'px';
          }
          if(offsetX+92>_this.canvasW){
            menu.style.left = (offsetX-88) + 'px';
          }else{
            menu.style.left = offsetX + 'px';
          }

          canvas.onmouseover = function (e) {
            if (e.target.className == 'canvas') {
              _this.cMenuShow = false;
              canvas.onmouseover = null;
            }
          }
          document.onmousedown = function (e) {
            if (e.target.className != 'menu_label' && e.target.className != 'menu' && e.button == 0) {
              _this.cMenuShow = false;
              document.onmousedown = null;
            }
          }
        }
        if(e.button ==0 && e.target.className =='canvas' &&  canvas.style.backgroundImage !=''){
          let obj = e.target;
          obj.style.cursor = 'move';
          obj.onmouseup = function () {
            obj.style.cursor = 'default';
            obj.onmouseup = null;
          };
          document.onmouseup = function () {
            obj.style.cursor = 'default';
            document.onmousemove = null;
            document.onmouseup = null;
          };

          const disX = e.clientX;
          const disY = e.clientY;

          const left = _this.dx;
          const top = _this.dy;
          //图纸背景移动
          document.onmousemove = function (e) {
            let changeLeft = (left + (e.clientX - disX));
            let changeTop = (top + (e.clientY - disY));
            _this.dx = changeLeft;
            _this.dy = changeTop;
          }
        }
      }
      canvas.oncontextmenu = function () {
        return false;
      }
    }
  }
</script>

<style scoped>
  /*==========================================================*/
  .container {
    position: relative;
    width: 1580px;
    height: 830px;
    margin: auto;
  }

  .canvas {
    position: relative;
    float: left;
    border: 1px solid #e0e0e0;
    background-repeat: no-repeat;
    moz-user-select: -moz-none;
    -moz-user-select: none;
    -o-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .tools {
    position: relative;
    width: 400px;
    height: 830px;
    margin-left: 5px;
    float: left;
    border: 1px solid #e0e0e0;
    background: #ffffff;
    overflow-y: auto;
  }

  .createBtn {
    position: relative;
    margin: 20px auto 10px auto;
    text-align: center;
  }

  .dataArea {
    position: relative;
    width: 90%;
    margin: 10px auto;
    text-align: center;
  }
  .sn{height: 30px;line-height: 30px;font-weight: bold; color:#ff0bec;font-size: 18px;}
  .dataTitle{text-align: left; border-bottom:1px dashed #c9c9c9;font-weight: bold;}
  .dataLabel{ text-align: left;width: 30px; color: #6d6d6d;font-size: 12px;}
  .angleBtn{ width: 50px;}
  .upload{margin-top: 5px;}
  .menu {
    position: absolute;
    left: 100px;
    top: 500px;
    background: #ffffff;
    width: 90px;
    cursor: default;
    border: 1px solid #eaeaea;
    border-radius: 3px;
    z-index: 999;
  }

  .menu_label {
    position: relative;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #636363;
    margin: 5px 5px 5px 5px;
  }

  .menu_label:hover {
    background: #ECF5FF;
    cursor: pointer;
  }

  .menu_line {
    position: relative;
    width: 100%;
    height: 1px;
    background: #eaeaea
  }
  .footer{text-align: center;}
</style>



// WEBPACK FOOTER //
// src/components/device/TowerLayout.vue